"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WYSIWYG_EDITOR_LANGUAGE = exports.cleanPathFromLocale = exports.getCountryFromAcceptLanguage = exports.getIsoLocaleFromBrowserLanguage = exports.getLocaleRedirectionFromCloudflareHeader = exports.getLocaleLabelTranslationKey = exports.normalizeUserStoredLocale = exports.convertToCommandLang = exports.getIsoLocaleFromLocale = exports.getIsoLocale = exports.getDashboardLocaleFromCountry = exports.getAllowedDashboardLanguages = exports.hasMultipleLocales = exports.getLocalesByCountry = exports.getLanguageLabel = exports.convertDayToLocale = exports.resolveUntranslatedSpanishEmailLocale = exports.resolveEmailLocale = exports.getLocaleFromCountry = exports.getIsoLocaleFromCountry = exports.getUserMessageForLocale = exports.buildUntranslatedUserMessage = exports.buildLocaleRecord = exports.getLocalesFromIsoLocale = void 0;
const enums_1 = require("../../enums");
const command_1 = require("../../enums/command");
const country_1 = require("../enums/country");
const locales_1 = require("../enums/locales");
const getLocalesFromIsoLocale = (isoLocale) => {
    if (isoLocale?.toLowerCase()?.includes("fr")) {
        return locales_1.Locales.FR;
    }
    if (isoLocale?.toLowerCase()?.includes("es")) {
        return locales_1.Locales.ES;
    }
    if (isoLocale?.toLowerCase()?.startsWith("de")) {
        return locales_1.Locales.DE;
    }
    if (isoLocale?.toLowerCase()?.includes("en")) {
        return locales_1.Locales.EN;
    }
    return locales_1.Locales.EN;
};
exports.getLocalesFromIsoLocale = getLocalesFromIsoLocale;
const buildLocaleRecord = (record) => record;
exports.buildLocaleRecord = buildLocaleRecord;
const buildUntranslatedUserMessage = (text) => ({
    [locales_1.Locales.EN]: text,
    [locales_1.Locales.FR]: text,
});
exports.buildUntranslatedUserMessage = buildUntranslatedUserMessage;
const getUserMessageForLocale = (userMessage, locale) => userMessage[locale === locales_1.Locales.FR ? locales_1.Locales.FR : locales_1.Locales.EN];
exports.getUserMessageForLocale = getUserMessageForLocale;
const getIsoLocaleFromCountry = (country, storedLocale) => {
    if (country === country_1.OrganizationCountry.Canada) {
        return storedLocale === locales_1.Locales.FR ? locales_1.CadIsoLocale.FR : locales_1.CadIsoLocale.EN;
    }
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return storedLocale === locales_1.Locales.ES ? locales_1.UsaIsoLocale.ES : locales_1.UsaIsoLocale.EN;
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return locales_1.GbIsoLocale.EN;
    }
    if (country === country_1.OrganizationCountry.Australia) {
        return locales_1.AuIsoLocale.EN;
    }
    if (country === country_1.OrganizationCountry.Ireland) {
        return locales_1.IeIsoLocale.EN;
    }
    if (country === country_1.OrganizationCountry.Germany) {
        return storedLocale === locales_1.Locales.EN ? locales_1.DeIsoLocale.EN : locales_1.DeIsoLocale.DE;
    }
    return storedLocale === locales_1.Locales.FR ? locales_1.CadIsoLocale.FR : locales_1.CadIsoLocale.EN;
};
exports.getIsoLocaleFromCountry = getIsoLocaleFromCountry;
const getLocaleFromCountry = (country, storedLocale) => {
    if (country === country_1.OrganizationCountry.Canada) {
        return locales_1.CadLocales[storedLocale] || locales_1.CadLocales.FR;
    }
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return locales_1.UsaLocales[storedLocale] || locales_1.UsaLocales.EN;
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return locales_1.GbLocales[storedLocale] || locales_1.GbLocales.EN;
    }
    if (country === country_1.OrganizationCountry.Australia) {
        return locales_1.AuLocales[storedLocale] || locales_1.AuLocales.EN;
    }
    if (country === country_1.OrganizationCountry.Ireland) {
        return locales_1.IeLocales[storedLocale] || locales_1.IeLocales.EN;
    }
    if (country === country_1.OrganizationCountry.Germany) {
        return locales_1.DeLocales[storedLocale] || locales_1.DeLocales.DE;
    }
    return storedLocale;
};
exports.getLocaleFromCountry = getLocaleFromCountry;
const resolveEmailLocale = (lang, country) => {
    if (!country) {
        return lang.toLowerCase();
    }
    return `${lang.toLowerCase()}-${country_1.ORGANIZATION_COUNTRY_MAP[country].countryCode}`;
};
exports.resolveEmailLocale = resolveEmailLocale;
const resolveUntranslatedSpanishEmailLocale = (lang) => lang === locales_1.Locales.ES ? locales_1.Locales.EN : lang;
exports.resolveUntranslatedSpanishEmailLocale = resolveUntranslatedSpanishEmailLocale;
const convertDayToLocale = (day, locale) => {
    const dayTranslationFr = {
        [enums_1.Day.Monday]: "lundi",
        [enums_1.Day.Tuesday]: "mardi",
        [enums_1.Day.Wednesday]: "mercredi",
        [enums_1.Day.Thursday]: "jeudi",
        [enums_1.Day.Friday]: "vendredi",
        [enums_1.Day.Saturday]: "samedi",
        [enums_1.Day.Sunday]: "dimanche",
    };
    const dayTranslationDe = {
        [enums_1.Day.Monday]: "Montag",
        [enums_1.Day.Tuesday]: "Dienstag",
        [enums_1.Day.Wednesday]: "Mittwoch",
        [enums_1.Day.Thursday]: "Donnerstag",
        [enums_1.Day.Friday]: "Freitag",
        [enums_1.Day.Saturday]: "Samstag",
        [enums_1.Day.Sunday]: "Sonntag",
    };
    if (locale === locales_1.Locales.FR) {
        return dayTranslationFr[day];
    }
    if (locale === locales_1.Locales.DE) {
        return dayTranslationDe[day];
    }
    return day;
};
exports.convertDayToLocale = convertDayToLocale;
const getLanguageLabel = (locale) => {
    switch (locale) {
        case locales_1.Locales.FR:
            return "french";
        case locales_1.Locales.ES:
            return "spanish";
        case locales_1.Locales.DE:
            return "german";
        default:
            return "english";
    }
};
exports.getLanguageLabel = getLanguageLabel;
const getLocalesByCountry = (country) => {
    switch (country) {
        case country_1.OrganizationCountry.Canada:
            return [locales_1.Locales.FR, locales_1.Locales.EN];
        case country_1.OrganizationCountry.UnitedStates:
            return [locales_1.Locales.EN, locales_1.Locales.ES];
        case country_1.OrganizationCountry.Germany:
            return [locales_1.Locales.DE];
        case country_1.OrganizationCountry.GreatBritain:
        case country_1.OrganizationCountry.Australia:
        case country_1.OrganizationCountry.NewZealand:
        case country_1.OrganizationCountry.Ireland:
            return [locales_1.Locales.EN];
        default:
            return [locales_1.Locales.EN];
    }
};
exports.getLocalesByCountry = getLocalesByCountry;
const hasMultipleLocales = (country) => {
    return (0, exports.getLocalesByCountry)(country).length > 1;
};
exports.hasMultipleLocales = hasMultipleLocales;
const getAllowedDashboardLanguages = (country) => {
    if (country === country_1.OrganizationCountry.Canada) {
        return [locales_1.Locales.FR, locales_1.Locales.EN];
    }
    if (country === country_1.OrganizationCountry.Germany) {
        return [locales_1.Locales.DE, locales_1.Locales.EN];
    }
    return [locales_1.Locales.EN];
};
exports.getAllowedDashboardLanguages = getAllowedDashboardLanguages;
const getDashboardLocaleFromCountry = (country, requestedLocale) => {
    const allowedLanguages = (0, exports.getAllowedDashboardLanguages)(country);
    if (allowedLanguages.includes(requestedLocale)) {
        return requestedLocale;
    }
    return allowedLanguages.includes(locales_1.Locales.EN) ? locales_1.Locales.EN : allowedLanguages[0];
};
exports.getDashboardLocaleFromCountry = getDashboardLocaleFromCountry;
const getIsoLocale = (locale) => {
    switch (locale) {
        case "en":
            return locales_1.UsaIsoLocale.EN;
        case "en-US":
            return locales_1.UsaIsoLocale.EN;
        case "en-CA":
            return locales_1.CadIsoLocale.EN;
        case "es":
            return locales_1.UsaIsoLocale.ES;
        case "es-US":
            return locales_1.UsaIsoLocale.ES;
        case "fr":
            return locales_1.CadIsoLocale.FR;
        case "fr-CA":
            return locales_1.CadIsoLocale.FR;
        case "en-GB":
            return locales_1.GbIsoLocale.EN;
        case "en-AU":
            return locales_1.AuIsoLocale.EN;
        case "en-IE":
            return locales_1.IeIsoLocale.EN;
        case "de":
            return locales_1.DeIsoLocale.DE;
        case "de-DE":
            return locales_1.DeIsoLocale.DE;
        case "en-DE":
            return locales_1.DeIsoLocale.EN;
        default:
            throw new Error(`Unsupported locale: ${locale}`);
    }
};
exports.getIsoLocale = getIsoLocale;
const getIsoLocaleFromLocale = (locale) => {
    if (locale === locales_1.Locales.FR) {
        return locales_1.CadIsoLocale.FR;
    }
    else if (locale === locales_1.Locales.ES) {
        return locales_1.UsaIsoLocale.ES;
    }
    else if (locale === locales_1.Locales.DE) {
        return locales_1.DeIsoLocale.DE;
    }
    else {
        return locales_1.UsaIsoLocale.EN;
    }
};
exports.getIsoLocaleFromLocale = getIsoLocaleFromLocale;
const convertToCommandLang = (locale) => {
    if (locale === locales_1.Locales.FR) {
        return command_1.CommandLang.FR;
    }
    if (locale === locales_1.Locales.ES) {
        return command_1.CommandLang.ES;
    }
    if (locale === locales_1.Locales.DE) {
        return command_1.CommandLang.DE;
    }
    return command_1.CommandLang.EN;
};
exports.convertToCommandLang = convertToCommandLang;
const normalizeUserStoredLocale = (locale) => {
    return locale === locales_1.Locales.ES ? locales_1.Locales.EN : locale;
};
exports.normalizeUserStoredLocale = normalizeUserStoredLocale;
const getLocaleLabelTranslationKey = (locale) => {
    if (locale === locales_1.Locales.FR) {
        return "common.French";
    }
    if (locale === locales_1.Locales.ES) {
        return "common.Spanish";
    }
    if (locale === locales_1.Locales.DE) {
        return "common.German";
    }
    return "common.English";
};
exports.getLocaleLabelTranslationKey = getLocaleLabelTranslationKey;
const getLocaleRedirectionFromCloudflareHeader = (countryByCloudflareHeader, isoLocale, locale) => {
    if (countryByCloudflareHeader === "United States" && !isoLocale.includes("US")) {
        return locales_1.UsaIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Canada" && !isoLocale.includes("CA")) {
        return locale === locales_1.Locales.EN ? locales_1.CadIsoLocale.EN : locales_1.CadIsoLocale.FR;
    }
    if (countryByCloudflareHeader === "United Kingdom" && !isoLocale.includes("GB")) {
        return locales_1.GbIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Australia" && !isoLocale.includes("AU")) {
        return locales_1.AuIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Ireland" && !isoLocale.includes("IE")) {
        return locales_1.IeIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Germany" && !isoLocale.includes("DE")) {
        return locales_1.DeIsoLocale.DE;
    }
};
exports.getLocaleRedirectionFromCloudflareHeader = getLocaleRedirectionFromCloudflareHeader;
const getIsoLocaleFromBrowserLanguage = (browserLanguage) => {
    if (browserLanguage.startsWith("fr")) {
        return locales_1.CadIsoLocale.FR;
    }
    else if (browserLanguage.startsWith("es")) {
        return locales_1.UsaIsoLocale.ES;
    }
    else if (browserLanguage.startsWith("de")) {
        return locales_1.DeIsoLocale.DE;
    }
    else if (browserLanguage.startsWith("en-AU")) {
        return locales_1.AuIsoLocale.EN;
    }
    else if (browserLanguage.startsWith("en-GB")) {
        return locales_1.GbIsoLocale.EN;
    }
    else if (browserLanguage.startsWith("en-IE")) {
        return locales_1.IeIsoLocale.EN;
    }
    else if (browserLanguage.toLowerCase().startsWith("en-de")) {
        return locales_1.DeIsoLocale.EN;
    }
    else if (browserLanguage.startsWith("en")) {
        return locales_1.UsaIsoLocale.EN;
    }
    else {
        return locales_1.UsaIsoLocale.EN; // default
    }
};
exports.getIsoLocaleFromBrowserLanguage = getIsoLocaleFromBrowserLanguage;
const getCountryFromAcceptLanguage = (acceptLanguage) => {
    if (acceptLanguage.includes("fr-CA") || acceptLanguage.includes("en-CA")) {
        return country_1.OrganizationCountry.Canada;
    }
    if (acceptLanguage.includes("en-GB")) {
        return country_1.OrganizationCountry.GreatBritain;
    }
    if (acceptLanguage.includes("en-AU")) {
        return country_1.OrganizationCountry.Australia;
    }
    if (acceptLanguage.includes("en-IE")) {
        return country_1.OrganizationCountry.Ireland;
    }
    if (acceptLanguage.includes("de-DE") || acceptLanguage.includes("en-DE")) {
        return country_1.OrganizationCountry.Germany;
    }
    return undefined;
};
exports.getCountryFromAcceptLanguage = getCountryFromAcceptLanguage;
const cleanPathFromLocale = (path) => {
    return path.replace(/^\/(en-CA|en-US|fr-CA|en-ES|de-DE|en-DE)\//, "/");
};
exports.cleanPathFromLocale = cleanPathFromLocale;
exports.WYSIWYG_EDITOR_LANGUAGE = {
    [locales_1.Locales.EN]: undefined,
    [locales_1.Locales.FR]: "fr",
    [locales_1.Locales.ES]: "es",
    [locales_1.Locales.DE]: "de",
};
